export default {
  name: "ConnectionSuccess",
  props: {
    title: {
      type: String,
      default: "🎉Account authorisation successful🎉"
    },
    detail: {
      type: String,
      default: "You can now close this window."
    }
  }
};